function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n");

var SvgBotHead = function SvgBotHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "785pt",
    height: "557pt",
    viewBox: "0 -0.07709750533103943 785 557.1541748046875",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 785,
    height: 557,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), _ref2, React.createElement("path", {
    d: "M3563.2993201257727,5568.900226624777c-620,-63,-1217.000000000001,-268,-1736.0000000000016,-596c-115,-72,-308,-209,-389,-275c-622.9999999999992,-511,-1048,-1147,-1205,-1804c-52,-218,-64,-322,-64,-545c0,-234,15,-352,69.99999999999994,-542c28,-99,91.00000000000006,-265,124,-327c100,-189,221.00000000000006,-353,370.00000000000006,-501c211,-212,421.9999999999993,-361,716.9999999999998,-509c433.00000000000045,-217,957.0000000000014,-365,1558.0000000000014,-441c148,-18,217,-20,912,-20c695.9999999999964,0,763.9999999999964,2,909.9999999999964,20c1479,190,2469,810,2752,1725c216,701,31,1513,-513,2248c-159,215,-421,490,-626,658c-605,495,-1268,786,-2039.999999999999,895c-132.99999999999818,18,-699.9999999999977,28,-839.9999999999977,14ZM4213.299320125772,5168.900226624777c955.9999999999973,-87,1859.9999999999973,-573,2464.9999999999973,-1325c257,-320,453,-706,534,-1052c70,-299,68,-623,-4,-876c-199,-694,-913,-1196,-2020,-1421c-425,-86,-857.9999999999973,-122,-1389.9999999999968,-113c-429,7,-706,32,-1065,98c-1142.0000000000016,208,-1901.0000000000014,724,-2103,1429c-71,246,-77,571,-16,845c218,978,1127,1894,2235,2255c238,77,523,137,754,159c137,12,476,13,609.9999999999995,1Z",
    transform: "matrix(0.1 0 0 -0.1 0 557)",
    style: {
      fill: "#54596E"
    }
  }), React.createElement("path", {
    d: "M3625,4547.199546750448c-433,-46,-788,-150,-1165,-341c-684,-347,-1161,-894,-1286,-1474c-28,-128,-26,-385,4,-503c58,-234,163,-409,356,-595c223,-214,545,-386,943,-502c902,-264,2201.000000000002,-249,3058.000000000002,35c800,266,1236,766,1202,1377c-23,398,-221,791,-579,1145c-460,457,-1085,751,-1798,848c-162,22,-569.0000000000018,28,-735.0000000000018,10ZM2985,3058.1995467504476c197,-57,415,-193,519,-324c246,-309,161,-625,-191,-708c-103,-24,-300,-15,-417,20c-297,89,-538,286,-627,513c-34,88,-33,218,3,295c51,110,162,190,309,223c99,23,290,14,404,-19ZM5318.000000000002,3077.1995467504476c142,-34,241,-106,294,-213c29,-59,33,-76,33,-147c-1,-197,-131,-389,-364,-540c-153,-99,-321,-153,-501,-162c-250,-11,-433,73,-508,235c-22,48,-26,70,-26,142c1,149,56,261,199,405c137,136,310,230,510,275c101,23,276,25,363,5Z",
    transform: "matrix(0.1 0 0 -0.1 0 557)",
    style: {
      fill: "#54596E"
    }
  }), React.createElement("ellipse", {
    id: "e1_ellipse",
    cx: 282.13619995116983,
    cy: 305.2000427246114,
    style: {
      fill: "#55A6FF",
      stroke: "black",
      strokeWidth: 1
    },
    rx: 72.1689,
    ry: 50.656,
    transform: "matrix(0.955935 0.383462 -0.383462 0.955935 141.087 -98.72)"
  }), React.createElement("ellipse", {
    id: "e2_ellipse",
    cx: 480.4577941894509,
    cy: 226.9438171386739,
    style: {
      fill: "#55A6FF",
      stroke: "black",
      strokeWidth: 1
    },
    rx: 72.1689,
    ry: 50.656,
    transform: "matrix(0.956924 -0.401977 0.401977 0.956924 -55.3026 279.088)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBotHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bot-head.54ec0c10.svg";
export { ForwardRef as ReactComponent };